module.exports = __webpack_public_path__ + "static/img/demand-widget-3.3b4d6f43.png";